import { timelogsApi } from '@/api/timelogsApi';
import { yandexTrackerApi } from '@/api/yandexTrackerApi';
import { ViewTable } from '@/configs/ViewTable';
import { WeeklyWorkLog } from '@/types';
import { transformTimelogToWeeklyWorkLog } from '@/utils/transformTimelog';
import { transformYLogToWeeklyWorkLog } from '@/utils/transformWorklog';

import { LogsMode } from './logsMode';

/** Логи пользователя за период из системы режима; userId — id в этой системе (uid Яндекса или uuid) */
export const fetchUserLogs = async ({
  mode,
  userId,
  from,
  to,
  signal,
  view,
}: {
  mode: LogsMode;
  userId: string;
  from: string;
  to: string;
  signal?: AbortSignal;
  view?: ViewTable;
}): Promise<WeeklyWorkLog[]> => {
  if (mode === LogsMode.v2) {
    const timelogs = await timelogsApi.searchUserTimelogs({ userId, from, to, signal });

    return timelogs.map(transformTimelogToWeeklyWorkLog);
  }

  const yLogs = await yandexTrackerApi.getAllUserWorkLogs({
    createdBy: userId,
    from,
    to,
    signal,
    view,
  });

  return yLogs.map(transformYLogToWeeklyWorkLog);
};
